<template>
    <div class="modal fade">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h3 class="modal-title"><i class="fas fa-exclamation-circle left-align"></i>Disclaimer</h3>
                    <button type="button" class="close" data-dismiss="modal" @click="closeModal()">&times;</button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <p>I am aware of the use of third-party elements in this website and they are used in accordance to their respective guidelines of use.</p>
                    <p>It is within my rights to add, remove, or modify the contents on this website without prior notice at any time.</p>
                    <p>Information submitted by users is used and stored only for contact purposes in order to aid development of this website. This will not be used for any marketing purposes.</p>
                    <p>I do not guarantee that this website is free of errors, viruses, or any other damaging elements.</p>
                    <p>If there is any issue related to copyright infringement, inappropriate content, misleading information, or to reuse contents from this website, please contact me on <a href="mailto:jv@sunarja.com">jv@sunarja.com.</a></p>
                    <p id="last-updated">Last reviewed: 31 December 2020</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    methods: {
        ...mapActions(['showDisclaimerModal']),
        closeModal: function(){
            this.showDisclaimerModal(false);
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    #last-updated {
        text-align: center;
        font-size: 0.8rem;
        color: $colour-grey-primary;
    }
}
</style>
